import React, { Component } from 'react';
import {Topic, TextHolder, Footer, ExploreData} from '../../Components/contentHolders/contentHolders.js';








export class ChapterTen extends Component {

  render() {
    return (
      <section className="Content">
        <div className="content-holder-topic">
        <div className="content-holder-inner fade">

        <Topic topicNumber={this.props.topicNumber} topicTitle={this.props.topicTitle} topicText={this.props.topicText} />



          <TextHolder textTitle="State of Southeast Asian Tech Report 2018"/>
          <div className="block-outer block-outer-textholder">
            <div className="block-inner block-inner-textholder">
              <div className="text-holder">
                <p>First edition</p>
              </div>
            </div>
          </div>


                            <TextHolder text="This is the first State of Southeast Asian Tech Report which offers a comprehensive look at the tech startup ecosystem in six regional countries, namely Indonesia, Malaysia, the Philippines, Singapore, Thailand and Vietnam."/>

                            <TextHolder text="Over 100 key players in the SEA tech startup ecosystem took part in our wide-ranging survey,  including entrepreneurs, investors and startup employees. The survey findings offer insights on the region’s advantages and challenges, helping us to better understand how it may compete at a global level."/>

                            <TextHolder text="All of the survey’s respondents agreed unanimously that the region’s tech startup ecosystem would continue to expand in the next one to two years. Funding and exits reached new heights, demonstrating market acceptance and more significantly, providing recognition that regional startups were as good and as valuable as their counterparts in the U.S. Acquisitions remained the dominant method of exits, and have hiked upwards for the third year in a row."/>

                            <TextHolder text="The region is also growing more integrated. As SEA moves closer to becoming a common market, governments are encouraging their enterprises to collaborate. Just as intra- trade is increasing in the region, cross-border deals are on the rise. Indonesia-based Traveloka, Vietnamese e-commerce company Tiki and other SEA startups are expanding regionally. Meanwhile, many other investors are going beyond their borders as they eye investment opportunities in neighboring countries."/>

                            <TextHolder text="2017 was marked by many exciting developments including Grab’s acquisition of Uber in SEA and Go-Jek’s aggressive expansion across the region. Startups exited via acquisitions, following the trend of the last few years. Singapore continued to be a major node for the SEA tech startup ecosystem. It remains a popular place to found and register startups, and it is still where most VCs and investors in the region are headquartered."/>

                            <TextHolder text="Looking ahead, the SEA ecosystem is expected to expand and become more vibrant. VC and corporate funds will flow to the region principally via Singapore. Unfortunately, although there is no lack of funds, there aren’t currently enough great creative ideas. Talent is and will remain a major challenge, and innovative ways will have to be found to manage the crunch. Governments will need to increase their activities and grow funds for tech startups as a way to pump new vibrancy into their economies, create new profitable companies and move to a digital economy."/>






        <ExploreData nextChapter={ this.props.nextChapter } />
        <Footer />

        </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/10.js